import React, { useState, useEffect, forwardRef } from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup';

import { useFormik } from "formik";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import ReactDatePicker from "react-datepicker";
import toast from "react-hot-toast";
import { BsChevronLeft, BsInfoCircle, BsSearch } from "react-icons/bs";
import { FaEyeSlash } from "react-icons/fa";
import { OtpModal } from '../Modals/OtpModal';
import { SuccessModal } from '../Modals/SuccessModal';
import * as Yup from 'yup';
import axiosInstance from '../../utils/axiosConfig'
import { aesDecrypted, aesEncryped, ivGenerator, rsaDecrypt, rsaEncrypt } from '../../utils/encryption'
import { keyGenerate } from '../../utils/requestId';
import { useAuth } from '../../contexts/auth';
import { Link } from 'react-router-dom';

const DEFAULT_DATE_STR = "2099-12-31";

const CustomDateInput = forwardRef(({ value, onClick, className, style, ...props }, ref) => {
    return (
        <InputGroup className="d-flex flex-nowrap w-100" style={style} ref={ref}>
            <Form.Control
                {...props}
                value={value || "31/12/2099"}
                readOnly
                style={{ backgroundColor: '#fff', cursor: 'default' }}
            />
            <InputGroup.Text onClick={onClick} style={{ cursor: 'pointer' }}>
                <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                    <rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect>
                    <line x1="16" x2="16" y1="2" y2="6"></line>
                    <line x1="8" x2="8" y1="2" y2="6"></line>
                    <line x1="3" x2="21" y1="10" y2="10"></line>
                    <path d="M8 14h.01"></path>
                    <path d="M12 14h.01"></path>
                    <path d="M16 14h.01"></path>
                    <path d="M8 18h.01"></path>
                    <path d="M12 18h.01"></path>
                    <path d="M16 18h.01"></path>
                </svg>
            </InputGroup.Text>
        </InputGroup>
    );
});

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Please enter corporate name greater than 3 letters")
    .required("Please enter corporate name")
    .matches("^[a-zA-Z-&' ]+$", "Enter Valid corporate name"),
  gstin: Yup.string()
    .required("GST is required")
    .matches(
      "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$",
      "Enter Valid GST IN"
    ),
  gsp: Yup.string().required("GSP is required"),
  username: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
  pan: Yup.string()
    .required("Pan no is required")
    .matches("[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}", "Enter Valid Pan Number")
    .max(10, "Pan number must be at max 10 characters"),
  mobileNumber: Yup.string()
    .trim()
    .matches("^((?!([0-5]))[0-9]{10})+$", "Enter Valid Mobile Number")
    .required("Mobile Number is required")
    .min(10, "Mobile number must be at least 10 digits")
    .max(10, "Mobile number must be at least 10 digits"),
  //    validDate: Yup.string().required('Valid date is required')
  //    emailId: Yup.string().required('Required'),
});

export const AddConsentForm = (props) => {
  // console.log(props)
  const { type, initialData, handleCloseModal, fetchData } = props;
  const [isChecked, setIsChecked] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [passwordText, setPasswordText] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [verificationToken, setVerificationToken] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState(null);
  // const [validUntill, setValidUntill] = useState(null);

    const showPassword = () => {
        setPasswordText(!passwordText);
    }

    // Get the 'updateUser' function from the auth context
    const { user, onUpdateUser: updateUser } = useAuth()
   
    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };
    const handleSuccessModal = () => setShowSuccessModal(true);

  // New function to handle verification
  const handleVerify = async () => {
    // Run validation first
    const errors = await consentForm.validateForm();
    if (Object.keys(errors).length > 0) {
      const touchedFields = {};
      Object.keys(consentForm.values).forEach((k) => (touchedFields[k] = true));
      consentForm.setTouched(touchedFields);
      return;
    }

    const values = { ...consentForm.values };
    values.ref = localStorage.getItem("portalRef", "");

    // --- FIX: Generate the requestId ONCE and store it ---
    const newRid = keyGenerate();
    setRequestId(newRid); // Store it in state for the submit call
    console.log(`[VERIFY] Generated and stored RequestId: ${newRid}`); // Debugging

    const payloadToEncrypt = { ...values, requestId: newRid };

    // Normalise validDate (same logic as handleSubmit)
    if (!payloadToEncrypt.validDate) {
      payloadToEncrypt.validDate = new Date(DEFAULT_DATE_STR).toISOString();
    } else if (payloadToEncrypt.validDate instanceof Date) {
      payloadToEncrypt.validDate = payloadToEncrypt.validDate.toISOString();
    } else if (typeof payloadToEncrypt.validDate === 'string' && !payloadToEncrypt.validDate.includes('T')) {
      payloadToEncrypt.validDate = new Date(payloadToEncrypt.validDate).toISOString();
    }

    const randKey = keyGenerate();
    const iv = ivGenerator();
    const session_key = rsaEncrypt(randKey);
    // const encryptPayload = aesEncryped(randKey, iv, JSON.stringify(values));
    const encryptPayload = aesEncryped(
      randKey,
      iv,
      JSON.stringify(payloadToEncrypt)
    );

    setVerifyLoader(true);
    setVerificationMessage(null);

    axiosInstance()
      .post(
        "consent-api/GSPUser/verify",
        { requestId: newRid, data: encryptPayload },
        { headers: { "session-key": session_key, "session-iv": iv } }
      )
      .then((res) => {
        setVerifyLoader(false);
        if (
          res.data.code === 200 &&
          res.data.verified &&
          res.data.verificationToken
        ) {
          setIsVerified(true);
          setVerificationToken(res.data.verificationToken);
          setVerificationMessage({
            type: "success",
            text: "Credentials verified successfully!",
          });
        } else {
          setIsVerified(false);
          setVerificationToken(null);
          setRequestId(null); // Clear requestId on failed verify
          setVerificationMessage({
            type: "error",
            text: res.data.message || "Verification failed",
          });
        }
      })
      .catch((err) => {
        setVerifyLoader(false);
        setIsVerified(false);
        setVerificationToken(null);
        setRequestId(null); // Clear requestId on error
        setVerificationMessage({ type: "error", text: err.toString() });
        // toast.error(err.toString());
      });
  };

  const handleSubmit = (values) => {
    // --- FIX: Add logging to check the state value ---
    console.log(`[SUBMIT] Using RequestId from state: ${requestId}`);

    if (!verificationToken) {
      toast.error("Please verify credentials before submitting");
      return;
    }

    // --- FIX: Add a specific check for the requestId from state ---
    if (!requestId) {
      toast.error("Missing RequestId. Please verify credentials again.");
      return;
    }

    // Clone & prepare payload
    const toSend = { ...values };

     // Handle Valid Date
     if (!toSend.validDate) {
         toSend.validDate = new Date(DEFAULT_DATE_STR).toISOString();
     } else if (toSend.validDate instanceof Date) {
         toSend.validDate = toSend.validDate.toISOString();
     } else if (typeof toSend.validDate === 'string' && !toSend.validDate.includes('T')) {
          toSend.validDate = new Date(toSend.validDate).toISOString();
     }

    // Ensure ref is sent on submit as well (same as verify)
    toSend.ref = localStorage.getItem("portalRef", "");

    // --- FIX: Add the requestId to the object BEFORE encrypting ---
    const payloadToEncrypt = { ...toSend, requestId: requestId };

    const randKey = keyGenerate();
    const iv = ivGenerator();
    const session_key = rsaEncrypt(randKey);
    // const encryptPayload = aesEncryped(randKey, iv, JSON.stringify(toSend));
    const encryptPayload = aesEncryped(
      randKey,
      iv,
      JSON.stringify(payloadToEncrypt)
    );

        // const rid = requestId || keyGenerate(); // reuse verify requestId if present
        const rid = requestId;

        const token = localStorage.getItem('token') || '';

        // For debugging, let's log the final object going to Axios
        const axiosPayload = {
            requestId: rid,
            data: encryptPayload,
            verificationToken,
            token: token
        };
        console.log('[SUBMIT] Final payload for Axios:', axiosPayload);

        setSubmitLoader(true);
        axiosInstance().post(
            'consent-api/GSPUser/submit',
            axiosPayload, // Send the full payload object
            { headers: { 'session-key': session_key, 'session-iv': iv } }
        ).then(res => {
            setSubmitLoader(false);
            try {
                if ([200, 1136].includes(res.data.code)) {
                    if (type === 'create') {
                        const updatedUser = { ...user, hasConsents: true };
                        updateUser(updatedUser);
                        handleSuccessModal(); // This will now be called correctly
                    } else { 
                        fetchData();
                        toast.success(res.data.message);
                        handleCloseModal();
                    }
                } else {
                    toast.error(res.data.message ? res.data.message : res.data.error?.message);
                }
            } catch (error) {
                console.error("Error processing successful response:", error);
                toast.error("Consent created, but there was a UI error.");
                // Still show the success modal so the user knows the main action worked
                if (type === 'create') {
                    handleSuccessModal();
                }
            }
        }).catch(err => {
            setSubmitLoader(false);
            // Add more detailed error logging
            console.error("Axios request failed:", err);
            toast.error(err.toString());
        });
    };

  // Update formik to use our new submit handler
  const consentForm = useFormik({
    initialValues: {
      ...initialData,
      emailId: user?.emailId || user?.email || initialData.emailId || "",
    },
    onSubmit: handleSubmit,
    validationSchema,
  });

     // Normalise validDate to a Date object for ReactDatePicker (Edit flow may pass a string)
     useEffect(() => {
     const v = consentForm.values.validDate;
     if (!v) {
         // No action
     } else {
         const d = new Date(v);
         if (!isNaN(d.valueOf())) {
             const isDefault = d.getFullYear() === 2099;
             consentForm.setFieldValue('validDate', isDefault ? null : d, false);
         }
     }
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, []);

     // If any fingerprint field changes post-verify, clear the verification state
     useEffect(() => {
       if (isVerified) {
         setIsVerified(false);
         setVerificationToken(null);
         setVerificationMessage(null);
       }
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [
       consentForm.values.gsp,
       consentForm.values.gstin,
       consentForm.values.username,
       consentForm.values.password,
     ]);

     // Auto-populate PAN from GSTIN
     useEffect(() => {
        const gstin = consentForm.values.gstin;
        if (gstin && gstin.length >= 12) {
             const extractedPan = gstin.substring(2, 12);
             if (consentForm.values.pan !== extractedPan) {
                 consentForm.setFieldValue('pan', extractedPan);
             }
        } else if ((!gstin || gstin.length < 12) && consentForm.values.pan) {
             consentForm.setFieldValue('pan', '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [consentForm.values.gstin]);


    return (
        <>
            <Form noValidate onSubmit={consentForm.handleSubmit}>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="gstin">
                            <Form.Label>GSTIN</Form.Label>
                            <Form.Control
                                name="gstin"
                                type="text"
                                placeholder="eg. 22AAAAA0000A1Z5"
                                onChange={consentForm.handleChange}
                                value={consentForm.values.gstin}
                                onBlur={consentForm.handleBlur}
                                isInvalid={consentForm.touched.gstin && !!consentForm.errors.gstin}
                                readOnly={type==="edit"? 1 : 0}
                            />
                            <Form.Control.Feedback type="invalid">
                                {consentForm.errors.gstin}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="corporate-name">
                            <Form.Label className='d-flex align-items-center'>
                                Corporate Name
                                <Button variant='link p-0 m-0 ms-3 lh-1 text-reset'
                                        title="Enter your registered corporate name"
                                ><BsInfoCircle className='fs-6' /></Button>
                            </Form.Label>
                            <Form.Control
                                required
                                name="name"
                                type="text"
                                value={consentForm.values.name}
                                placeholder="eg. ABC company"
                                onBlur={consentForm.handleBlur}
                                onChange={consentForm.handleChange}
                                isInvalid={consentForm.touched.name && !!consentForm.errors.name}
                                readOnly={type==="edit"? 1 : 0}

                            />
                            <Form.Control.Feedback type="invalid">
                                {consentForm.errors.name}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="gsp">
                            <Form.Label className='d-flex align-items-center'>
                                GSP
                                <Button variant='link p-0 m-0 ms-3 lh-1 text-reset'
                                        title="This is the GSP selected/added on the GSP portal. Not found your GSP? Add GSP - to know more, refer links on the bottom left pane"
                                ><BsInfoCircle className='fs-6' /></Button>
                            </Form.Label>
                            <Form.Select aria-label="Default select example"
                                name='gsp'
                                value={consentForm.values.gsp}
                                onChange={consentForm.handleChange}
                                isInvalid={consentForm.touched.gsp && !!consentForm.errors.gsp}
                                disabled={type==="edit"? 1 : 0}
                            >
                                <option value="">Select GSP</option>
                                <option value="Vayana">Vayana</option>
                                <option value="Cygnet">Cygnet</option>
                            </Form.Select>
                            {/* <ReactSelect
                                className="select-container"
                                classNamePrefix="select"
                                options={gspOptions}
                                onChange={(val)=> consentForm.setFieldValue('gsp', val.value)}
                                isClearable
                                name='gsp'
                                onBlur={consentForm.handleBlur}
                                isInvalid={consentForm.touched.gsp && !!consentForm.errors.gsp}
                            /> */}
                            <Form.Control.Feedback type="invalid">
                                {consentForm.errors.gsp}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="pan">
                            <Form.Label>PAN No.</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="eg. AAAAA0000A"
                                name='pan'
                                onChange={consentForm.handleChange}
                                value={consentForm.values.pan}
                                onBlur={consentForm.handleBlur}
                                isInvalid={consentForm.touched.pan && !!consentForm.errors.pan}
                                disabled={true}
                            />
                            <Form.Control.Feedback type="invalid">
                                {consentForm.errors.pan}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6} className='mb-3'>
                        <Form.Group className="mb-3">
                            <Form.Label>Valid until</Form.Label>
                            <div className="w-100 d-block">
                                <ReactDatePicker
                                    selected={consentForm.values.validDate ? new Date(consentForm.values.validDate) : null}
                                    onChange={(date) => consentForm.setFieldValue('validDate', date)}
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date()}
                                    openToDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                                    customInput={<CustomDateInput />}
                                    wrapperClassName="w-100 d-block"
                                    popperPlacement="bottom-start"
                                />
                            </div>
                             <div className="invalid-feedback" style={{display: (consentForm.touched.validDate && !!consentForm.errors.validDate) ? 'block' : 'none'}}>{consentForm.errors.validDate}</div>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="mobileNumber">
                            <Form.Label>Mobile No.</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="eg. 7856784567"
                                name='mobileNumber'
                                onChange={consentForm.handleChange}
                                value={consentForm.values.mobileNumber}
                                onBlur={consentForm.handleBlur}
                                isInvalid={consentForm.touched.mobileNumber && !!consentForm.errors.mobileNumber}
                                readOnly={false}

                            />
                            <Form.Control.Feedback type="invalid">
                                {consentForm.errors.mobileNumber}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <hr className='border-primary' />
                    </Col>
                    {type === 'edit' && (
                         <div className="alert alert-info py-2 my-2">
                         Changes to username/password require verification.
                    </div>
                    )}
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="username">
                            <Form.Label className='d-flex align-items-center'>
                                Username
                                <Button variant='link p-0 m-0 ms-3 lh-1 text-reset'
                                        title="This is the GSP username used for the E-way bill portal. To know more, refer links on the bottom left pane"
                                ><BsInfoCircle className='fs-6' /></Button>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="eg. john"
                                name='username'
                                onChange={consentForm.handleChange}
                                value={consentForm.values.username}
                                onBlur={consentForm.handleBlur}
                                isInvalid={consentForm.touched.username && !!consentForm.errors.username}
                            />
                            <Form.Control.Feedback type="invalid">
                                {consentForm.errors.username}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3" controlId="password">
                            <Form.Label className='d-flex align-items-center'>
                                Password 
                                <Button variant='link p-0 m-0 ms-3 lh-1 text-reset'
                                        title="This is the GSP password used for the E-way bill portal. To know more, refer links on the bottom left pane"
                                ><BsInfoCircle className='fs-6' /></Button>
                            </Form.Label>
                            <InputGroup className="mb-3">
                            <Form.Control
                                type={passwordText ? "text": "password"} 
                                placeholder="eg. password"
                                name='password'
                                onChange={consentForm.handleChange}
                                value={consentForm.values.password}
                                onBlur={consentForm.handleBlur}
                                isInvalid={consentForm.touched.password && !!consentForm.errors.password}
                                icon={<svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect><line x1="16" x2="16" y1="2" y2="6"></line><line x1="8" x2="8" y1="2" y2="6"></line><line x1="3" x2="21" y1="10" y2="10"></line><path d="M8 14h.01"></path><path d="M12 14h.01"></path><path d="M16 14h.01"></path><path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path></svg>}
                                
                            />
                            <InputGroup.Text><FaEyeSlash onClick={showPassword} cursor={"pointer"}/></InputGroup.Text>
                            </InputGroup>
                            

              <Form.Control.Feedback type="invalid">
                {consentForm.errors.password}
              </Form.Control.Feedback>
              {type === "edit" && (
                <Form.Text className="text-muted">
                  For security, please re-enter the password.
                </Form.Text>
              )}
            </Form.Group>
          </Col>
          {/* Display verification status message if available */}
          {verificationMessage && (
            <Col md={12} className="mb-3">
              <div
                className={`alert ${
                  verificationMessage.type === "success"
                    ? "alert-success"
                    : "alert-danger"
                }`}
              >
                {verificationMessage.text}
              </div>
            </Col>
          )}

          {type === "create" ? (
            <Col md={12}>
              <Form.Group className="mb-4 mt-3">
                <Form.Check
                  type="checkbox"
                  id=""
                  label={
                    <span>
                      I accept IBDIC's{" "}
                      {/* <a 
                                               href={`${process.env.REACT_APP_BASE_URL}consent-api/tc_master/privacy-policy/view`}
                                               target="_blank"
                                               rel="noopener noreferrer"
                                               className="text-danger text-decoration-underline"
                                               onClick={(e) => e.stopPropagation()}
                                           > */}
                      Privacy Policy {/* </a>{' '} */}
                      and{" "}
                      <a
                        href={`${process.env.REACT_APP_BASE_URL}/static/tc/terms-and-conditions.pdf`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-danger text-decoration-underline"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Terms and Conditions
                      </a>
                    </span>
                  }
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
              </Form.Group>
            </Col>
          ) : null}

          <Row className="mb-3 g-3">
            <Col md={6} className="">
              <Button
                variant="outline-dark"
                type="button"
                className="w-100"
                disabled={!isChecked && type === "create"}
                onClick={handleVerify}
                loading={verifyLoader}
              >
                Verify
              </Button>
            </Col>
            <Col md={6} className="">
              <Button
                variant="dark"
                type="submit"
                className="w-100"
                disabled={
                  type === "create" ? !isChecked || !isVerified : !isVerified
                }
                loading={submitLoader}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Row>
      </Form>

      <OtpModal showOtpModal={showOtpModal} setShowOtpModal={setShowOtpModal} />
      <SuccessModal
        showSuccessModal={showSuccessModal}
        setShowSuccessModal={setShowSuccessModal}
      />
    </>
  );
};
